webpackJsonp([2],{

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax_http_interceptor__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__ = __webpack_require__(73);


__webpack_require__(84).polyfill();





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
	data: function data() {
		return {
			_: _
		};
	}
});


/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	components: { Core: __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__["a" /* default */] }
}));

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);




var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__ = __webpack_require__(6);




window.loading = false;

$.ajaxSetup({
  beforeSend: function beforeSend(xhr, settings) {
    var index = '';
    var token_val = '';
    var enableLoading = false;
    if (settings.data) {
      var data = settings.data.split('&');
      var data = data.indexOf("enableLoading=true");
      enableLoading = data >= 0 ? true : false;
      settings.data = settings.data.replace("&enableLoading=false", "");
      settings.data = settings.data.replace("&enableLoading=true", "");
      var url = settings.data;
    } else if (settings.type == 'GET') {
      var data = settings.url.indexOf("enableLoading=true");
      enableLoading = data >= 0 ? true : false;
      settings.url = settings.url.replace("&enableLoading=false", "");
      settings.url = settings.url.replace("&enableLoading=true", "");
      var url = settings.url;
    }
    settings.url = settings.url.replace("?enableLoading=false", "");
    settings.url = settings.url.replace("?enableLoading=true", "");
    if (url) {
      var valid = url.indexOf("&");
      if (valid >= 0) {
        var suburl = url.split('&');
        var delimiter = '&';
      } else {
        var suburl = url.split('?');
        var delimiter = '?';
      }

      suburl.forEach(function (value, i) {
        if (value.substring(0, 6) == 'token=') {
          index = i;
          token_val = value.split('=');
          if (settings.data) {
            settings.data = url.replace(delimiter + suburl[index], "");
          } else if (settings.type == 'GET') {
            settings.url = url.replace(delimiter + suburl[index], "");
          }
          xhr.setRequestHeader('TOKEN', decodeURIComponent(token_val[1]));
        }
      });
    }
    if (enableLoading) {
      __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('enableLoading', enableLoading);
    }
    if ($.inArray(settings.type, ['POST', 'PUT', 'DELETE', 'PATCH']) > -1) {
      if (!_.isUndefined(settings.data)) {
        var csrf = {
          'csrf_name': function () {
            return $('meta[name="csrf_name"]').attr('content');
          }(),
          'csrf_value': function () {
            return $('meta[name="csrf_value"]').attr('content');
          }()
        };
      }
      return true;
    }
  }
});

$(document).ajaxSuccess(function (event, xhr, options) {

  if (!_.isUndefined(xhr.responseJSON)) {
    if (xhr.responseJSON.redirect) {
      window.location.href = xhr.responseJSON.redirect;
    }
  }
});

$(document).ajaxComplete(function (event, xhr, options) {
  if (window.navigator.userAgent.indexOf('Safari') >= 0 && window.navigator.userAgent.indexOf('Chrome') == -1) {
    $('.gridContainer').height('90vh');
    $('.gridContainer').css('overflow-y', 'auto');
  }
  if (xhr.getResponseHeader('X-Auth') == '0') {
    window.location = 'login';
  }

  if (xhr.status === 0) {
    location.reload();
  }

  if (xhr.getResponseHeader('X-Csrf-Name') && xhr.getResponseHeader('X-Csrf-Value')) {
    var csrf = {
      'csrf_name': xhr.getResponseHeader('X-Csrf-Name'),
      'csrf_value': xhr.getResponseHeader('X-Csrf-Value')
    };

    $.each(csrf, function (k, v) {
      $('meta[name="' + k + '"]').attr('content', v);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$ajax = $.ajax;

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(10)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[29]);


// WEBPACK FOOTER //
// js/core/core.eb26fbff3e90867fbf23.js